// Single source of truth for org user roles in the Material Tracker.
// Users are registered once (POST /org-user). Every role sees the same data tabs;
// the role only decides which reports the user can upload.

// Upload pages, keyed by the route under the user dashboard.
export const UPLOADS = {
  BOM: { to: "upload-bom", label: "BOM" },
  OPEN_PR: { to: "upload-open-pr", label: "PR Report" },
  OPEN_PO: { to: "upload-open-po", label: "PO Report" },
  DELIVERY: { to: "upload-delivery", label: "GRN Report" },
};

export const USER_ROLES = [
  { name: "PR User", value: "PR_USER", uploads: [UPLOADS.BOM, UPLOADS.OPEN_PR] },
  { name: "PO User", value: "PO_USER", uploads: [UPLOADS.OPEN_PO] },
  { name: "GRN User", value: "GRN_USER", uploads: [UPLOADS.DELIVERY] },
  { name: "Manager", value: "MANAGER", uploads: [] },
];

export const ALL_USER_ROLE_VALUES = USER_ROLES.map((role) => role.value);

// Upload pages the user's role may open.
export const getUserUploads = (user) =>
  USER_ROLES.find((role) => user?.userRole?.includes(role.value))?.uploads || [];

// Roles allowed to open one upload page.
export const getUploadRoles = (upload) =>
  USER_ROLES.filter((role) => role.uploads.includes(upload)).map((role) => role.value);

export const MATERIAL_ADMIN_BASE = "/admin";

// Kept as a hook so the admin screens can resolve their base path in one place.
export const useAdminBasePath = () => MATERIAL_ADMIN_BASE;

// Where a signed-in user lands after login.
export const getHomePath = (role) => {
  if (role === "SUPERADMIN") return "/superadmin-dashboard";
  if (role === "ADMIN") return MATERIAL_ADMIN_BASE;
  return "/dashboard";
};
